import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=60342f38&scoped=true&"
import script from "./ModuleCard.vue?vue&type=script&lang=ts&"
export * from "./ModuleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=60342f38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60342f38",
  null
  
)

export default component.exports